module.exports = __webpack_public_path__ + "img/entschenkopf.bda1c28b.jpg";